import React from 'react';

/**
 * Health Check Banner Component
 * Shows when backend connection has issues
 */
const HealthCheckBanner = ({ show, message, onRetry }) => {
  if (!show) return null;
  
  return (
    <div className="bg-red-600 border-l-4 border-red-800 text-white p-4 mb-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-red-200" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium">Backend Connection Issue</h3>
            <p className="text-sm text-red-100 mt-1">
              {message}
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <button 
            onClick={onRetry}
            className="bg-red-700 hover:bg-red-800 text-white px-3 py-1 rounded text-sm transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};

export default HealthCheckBanner;
